module.exports = __webpack_public_path__ + "img/1478592090.30066b33.jpg";